import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
// import { getSearchFindAreaList } from "@/api/api-operation-service";
import { getFindAreaList } from "@/api/api-basic";
let PiHomeMmapScreenCity = class PiHomeMmapScreenCity extends Vue {
    constructor() {
        super(...arguments);
        this.poptipVisible = false;
        this.provinceList = [];
        this.cityList = [];
        this.nameText = "";
        this.formInline = {
            cityId: "",
            provinceId: "",
        };
    }
    /**
     * 请求数据
     */
    async getCityList(parentId, level) {
        const ret = await getFindAreaList({
            parentId: parentId,
            regionLevel: level,
        });
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data || [];
            data.unshift({ name: "全部", pkid: "-1" });
            if (level == "1") {
                this.provinceList = data;
            }
            else if (level == "2") {
                this.cityList = data;
            }
        }
    }
    /**
     * 省选择
     */
    provinceClick(parentId) {
        var provinceId = parentId == "-1" ? "" : parentId;
        this.formInline.provinceId = provinceId;
        this.formInline.cityId = "";
        this.cityList = [];
        if (provinceId != "") {
            this.getCityList(provinceId, "2");
        }
        else {
            this.retureData();
        }
    }
    /**
     * 市选择
     */
    cityClick(parentId) {
        var cityId = parentId == "-1" ? "" : parentId;
        this.formInline.cityId = cityId;
        this.retureData();
    }
    /**
     * 返回数据
     */
    retureData() {
        this.poptipVisible = false;
        let provinceName = this.forCityName(this.provinceList, this.formInline.provinceId);
        let cityName = this.forCityName(this.cityList, this.formInline.cityId);
        this.nameText = provinceName + cityName;
        this.$emit("change", {
            ...this.formInline,
            provinceName: provinceName,
            cityName: cityName,
            nameText: this.nameText,
        });
    }
    /**
     * 找出名称
     */
    forCityName(list, pkid) {
        let name = "";
        list.map((item) => {
            if (item.pkid == pkid) {
                name = item.name;
            }
        });
        return name;
    }
    /**
     * 重置
     */
    resetting() {
        this.nameText = "";
        this.formInline.provinceId = "";
        this.formInline.cityId = "";
    }
    mounted() {
        this.getCityList("0", "1");
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeMmapScreenCity.prototype, "searchName", void 0);
PiHomeMmapScreenCity = __decorate([
    Component({
        components: {},
    })
], PiHomeMmapScreenCity);
export default PiHomeMmapScreenCity;
